export default __webpack_public_path__ + "static/media/low_carbs.3ebbf4f1.jpeg";